
import React, { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const LucacifyHomePage = lazy(() => import('../pages/home/lucacify-page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const TeamPage = lazy(() => import('../pages/team/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login'));
const NotFound = lazy(() => import('../pages/NotFound'));

// Allow separate admin deployment to use root path for Admin
const ADMIN_ONLY = import.meta.env.VITE_ADMIN_ONLY === 'true';

const routes: RouteObject[] = [
  {
    path: '/',
    element: ADMIN_ONLY ? <AdminPage /> : <LucacifyHomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/team',
    element: <TeamPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
